module.exports = __webpack_public_path__ + "static/human-illustration-d0603a339e8566b30e7a29e42deac595.svg";